import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const NationalSC = () => {
  const { t } = useTranslation('NationalSC');



  document.title = t('documentTitle');
  document.querySelector('meta[name="description"]').setAttribute('content', t('metaDescription'));



  return (
    <div>
      <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
        <LanguageSwitcher />
      </header>

      <div className="webview">
        <Container>
          <Row>
            <Col xs={12}>
              <Trans
                i18nKey="intro1"
                ns="NationalSC"
                components={[<strong key="0" />, <strong key="1" />]}
              />
              <br />
              <br />
              <Trans
                i18nKey="intro2"
                ns="NationalSC"
                components={[
                  <a
                    key="0"
                    title="National Savings Certificate"
                    href="https://www.goodreturns.in/personal-finance/investment/2018/07/national-savings-certificate-you-need-know-about-benefits-n-729611.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="1"
                    title="Public Provident Fund"
                    href="https://www.goodreturns.in/public-provident-fund-sschm2.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="2"
                    title="Bank Fixed Deposit Interest Rate"
                    href="https://www.goodreturns.in/fixed-deposit-interest-rates.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="3"
                    title="Post Office FDs"
                    href="https://www.goodreturns.in/personal-finance/investment/2018/04/special-fixed-deposit-schemes-offered-post-offices-695274.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="4"
                    title="Section 80C of the Income Tax Act"
                    href="https://www.goodreturns.in/section-80c-of-income-tax-act-s1.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="5"
                    title="Features of NSC & Why should you consider investing in NSC?"
                    href="https://www.goodreturns.in/personal-finance/investment/2018/07/national-savings-certificate-you-need-know-about-benefits-n-729611.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                ]}
              />

              <h2>{t('benefitsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('benefitsIntro') }} />
              <p dangerouslySetInnerHTML={{ __html: t('benefits1') }} />
              <ul>
                {t('benefitsList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('eligibilityHeader')}</h2>
              <Trans
                i18nKey="eligibilityIntro"
                ns="NationalSC"
                components={[<strong key="0" />]}
              />
              <br />
              <br />
              <ul>
                {t('eligibilityList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('documentsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('documentsIntro') }} />
              <ul>
                {t('documentsList', { returnObjects: true }).map((item, index) => (
                  <li key={index}>
                    <Trans
                      i18nKey={`documentsList.${index}`}
                      ns="NationalSC"
                      components={[
                        <a
                          key="0"
                          title="Permanent Account Number"
                          href="https://www.goodreturns.in/pan-card.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        />,
                        <a
                          key="1"
                          title="Aadhaar Card"
                          href="https://www.goodreturns.in/aadhar-card.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        />,
                      ]}
                    />
                  </li>
                ))}
              </ul>

              <h2>{t('whyInvestHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('whyInvestIntro') }} />
              <ul>
                {t('whyInvestList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('featuresHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('featuresIntro') }} />
              <ul style={{ listStyleType: "none", paddingLeft: 0, marginLeft: 0 }}>
                {t('featuresList', { returnObjects: true }).map((item, index) => (
                  <li key={index}>
                    <Trans
                      i18nKey={`featuresList.${index}`}
                      ns="NationalSC"
                      components={[<strong key="0" />]}
                    />
                    <br />
                    <br />
                  </li>
                ))}
              </ul>

              <h2>{t('taxBenefitsHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('taxBenefitsIntro') }} />

              <h2>{t('loanHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('loanIntro') }} />
              <ul>
                {t('loanList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('transferHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('transferIntro') }} />
              <ul>
                {t('transferList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('prematureHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('prematureIntro') }} />
              <ul>
                {t('prematureList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('duplicateHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('duplicateIntro') }} />
              <ul>
                {t('duplicateList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('typesHeader')}</h2>
              <p>
                <Trans
                  i18nKey="typesIntro"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </p>
              <p>
                <Trans
                  i18nKey="typesSingleHolder"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </p>
              <p dangerouslySetInnerHTML={{ __html: t('typesSingleHolderIntro') }} />
              <p>
                <Trans
                  i18nKey="typesJointA"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </p>
              <p dangerouslySetInnerHTML={{ __html: t('typesJointAIntro') }} />
              <p>
                <Trans
                  i18nKey="typesJointB"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </p>
              <p dangerouslySetInnerHTML={{ __html: t('typesJointBIntro') }} />

              <h2>{t('processHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('processIntro') }} />
              <ul>
                {t('processList', { returnObjects: true }).map((item, index) => (
                  <li key={index}>
                    <Trans
                      i18nKey={`processList.${index}`}
                      ns="NationalSC"
                      components={[
                        <a
                          key="0"
                          title="Permanent Account Number"
                          href="https://www.goodreturns.in/pan-card.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        />,
                        <a
                          key="1"
                          title="Aadhaar Card"
                          href="https://www.goodreturns.in/aadhar-card.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        />,
                      ]}
                    />
                  </li>
                ))}
              </ul>

              <h2>{t('transferNscHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('transferNscIntro') }} />

              <h2>{t('faqHeader')}</h2>
              <h4>
                <Trans
                  i18nKey="faq1Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq1AIntro') }} />
              <ul>
                {t('faq1AList', { returnObjects: true }).map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>
              <p dangerouslySetInnerHTML={{ __html: t('faq1AParagraph2') }} />
              <p dangerouslySetInnerHTML={{ __html: t('faq1AParagraph3') }} />
              <p dangerouslySetInnerHTML={{ __html: t('faq1AParagraph4') }} />
              <h4>
                <Trans
                  i18nKey="faq2Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq2A') }} />
              <h4>
                <Trans
                  i18nKey="faq3Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq3A') }} />
              <h4>
                <Trans
                  i18nKey="faq4Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq4A') }} />
              <h4>
                <Trans
                  i18nKey="faq5Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq5A') }} />
              <h4>
                <Trans
                  i18nKey="faq6Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq6A') }} />
              <h4>
                <Trans
                  i18nKey="faq7Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq7A') }} />
              <h4>
                <Trans
                  i18nKey="faq8Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq8A') }} />
              <h4>
                <Trans
                  i18nKey="faq9Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq9A') }} />
              <h4>
                <Trans
                  i18nKey="faq10Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq10A') }} />
              <h4>
                <Trans
                  i18nKey="faq11Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq11A') }} />
              <h4>
                <Trans
                  i18nKey="faq12Q"
                  ns="NationalSC"
                  components={[<strong key="0" />]}
                />
              </h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq12A') }} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default NationalSC;